/**
 * Format a DATE-ONLY entity field (league/tournament startDate) for display.
 * These are stored as UTC midnight of the calendar date the admin picked
 * (SettingsForm serializes `new Date('YYYY-MM-DD').toISOString()`), so the
 * UTC date IS the intended date — local formatting showed the PREVIOUS day
 * everywhere west of UTC (owner report 2026-09-13; admin dashboard's
 * Upcoming Events card caught 2026-09-17). Real timestamps (signups,
 * payments, audit logs) keep local formatting — never route them through
 * this.
 */
export default function formatDateOnly(
  value: string | number | Date | null | undefined,
  options: Intl.DateTimeFormatOptions = {}
): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { timeZone: 'UTC', ...options });
}
